import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Verify = () => {
  const location = useLocation();
  const navigate = useNavigate();


// Construct API URL
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3002';

  useEffect(() => {
    //console.log('Verify component mounted, location:', location);
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    //console.log('Token extracted:', token);

    if (token) {
      localStorage.setItem('token', token);
      axios.get(`${apiUrl}/api/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(response => {
          //console.log('Token verified:', response.data);
          navigate('/my-topics', { replace: true });
        })
        .catch(error => {
          //console.error('Token verification failed:', error);
          navigate('/', { replace: true });
        });
    } else {
      //console.log('No token found in URL');
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return <div>Verifying...</div>;
};

export default Verify;